<form
  name="shipReportsForm"
  novalidate=""
  class="ng-scope ng-pristine ng-invalid ng-invalid-required"
  *ngIf="hasEntitlements('REPORTS_SHIP') || hasEntitlements('REPORTS_SHORE')"
>
  <div class="card card-nc">
    <div class="card-heading">
      <i class="fa fa-bar-chart"></i
      ><span class="cardHeaderHeading"> Ship And Shore Reports</span
      ><span class="pull-right globalHeaderUserRole ng-binding"></span>
    </div>
    <div class="card-body">
      <div *ngIf="loading" class="col-1">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>
      <div class="row" *ngIf="!loading">
        <div class="col-sm-3 labelCommon">
          <div class="row">
            <div class="col-md-12">
              <span>Location</span>
              <select
                class="form-control input-sm ng-pristine ng-animate ng-invalid-remove ng-valid-add ng-invalid-required-remove ng-invalid-remove-active ng-valid ng-valid-add-active ng-invalid-required-remove-active ng-valid-required"
                name="location"
                id="location"
                required=""
                [(ngModel)]="location"
                (change)="changeView()"
              >
                <option *ngFor="let location of locations" [ngValue]="location">
                  {{ location.shipName }}
                </option>
              </select>
              <br />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              Report Timeline<br />
              <span class="staticText1 ng-binding">{{ report.frequency }}</span>
            </div>
          </div>
        </div>
        <div class="col-sm-9">
          <div class="row">
            <div class="col-md-12 labelCommon">
              <span>Report Name</span>
              <select
                class="form-control input-sm ng-pristine ng-animate ng-invalid-remove ng-valid-add ng-invalid-required-remove ng-invalid-remove-active ng-valid ng-valid-add-active ng-invalid-required-remove-active ng-valid-required"
                name="report"
                id="report"
                required
                [(ngModel)]="report"
                (change)="searchTransactions()"
              >
                <option *ngFor="let report of reportNames" [ngValue]="report">
                  {{ report.nameDesc }}
                </option>
              </select>
              <br />
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-4 labelCommon ng-hide"
              *ngIf="location?.shipName !== 'Shore'"
            >
              <span class="labelCommon">Batch</span> <br />
              <select
                class="form-control input-sm ng-pristine ng-animate ng-invalid-remove ng-valid-add ng-invalid-required-remove ng-invalid-remove-active ng-valid ng-valid-add-active ng-invalid-required-remove-active ng-valid-required"
                name="batchName"
                id="batchName"
                [(ngModel)]="batch"
                required
                (change)="searchTransactions()"
              >
                <option *ngFor="let batch of batches" [ngValue]="batch">
                  {{ batch.batchId }}
                </option>
              </select>
              <br />
            </div>
            <div
              class="form-group col-md-4"
              *ngIf="location?.shipName == 'Shore' || batch?.batchId == 'All'"
            >
              <span class="labelCommon">Start Date</span> <br />
              <div class="form-group">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control reports-date-picker"
                    name="dp1"
                    [(ngModel)]="startDate"
                    [maxDate]="endDate"
                    (change)="changedate()"
                    ngbDatepicker
                    #d1="ngbDatepicker"
                    (ngModelChange)="changeDate()"
                  />
                  <div class="input-group-append">
                    <button class="btn-cal input-sm" (click)="d1.toggle()">
                      <i class="fa fa-calendar"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-group col-md-4"
              *ngIf="location?.shipName == 'Shore' || batch?.batchId == 'All'"
            >
              <span class="labelCommon">End Date</span> <br />
              <div class="input-group">
                <input
                  type="text"
                  class="form-control reports-date-picker"
                  name="dp2"
                  [(ngModel)]="endDate"
                  [minDate]="startDate"
                  ngbDatepicker
                  (ngModelChange)="changeDate()"
                  #d2="ngbDatepicker"
                />
                <div class="input-group-append">
                  <button class="btn-cal input-sm" (click)="d2.toggle()">
                    <i class="fa fa-calendar"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="spinner-wrapper" *ngIf="spinner">
  <div role="status">
    <i class="fa fa-spinner fa-4x fa-pulse"></i>
  </div>
</div>
<div class="row searchResultsRow" *ngIf="transactions.length == 0 && !spinner">
  No reports found
</div>
<div class="searchResults ng-scope" *ngIf="transactions.length > 0 && !spinner">
  <div class="zeroPadding" *ngFor="let transaction of transactions">
    <div
      class="row searchResultsRow"
      (click)="
        showShipReportDetails(transaction.indexSeq, transaction.fileName)
      "
    >
      <div class="col-md-11">
        <div class="searchResultName">
          <div>{{ transaction.name }}</div>
        </div>
        <div class="searchResultDataName">{{ transaction.nameDesc }}</div>
        <div class="searchResultDataName" style="padding-top: 5px">
          Report Date:
          <span class="searchResultDataVal">{{
            transaction.dateCreated | date : "MM/dd/yyyy"
          }}</span>
          |
          <span class="searchResultDataVal">{{
            transaction.dateCreated | date : "h:mm:ss a"
          }}</span>
          | Report Type:
          <span class="searchResultDataVal">{{
            transaction.fileExtension
          }}</span>
          | Report Name:
          <span class="searchResultDataVal">{{
            removeFileExtension(transaction.fileName)
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
